module.exports = __webpack_public_path__ + "fonts/761ba19.otf";